import * as React from "react";

export default function HomeFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M10.3 2.9a2.5 2.5 0 0 1 3.4 0l6.6 5.1c.46.36.7.9.7 1.47V20a2 2 0 0 1-2 2h-3.2a1 1 0 0 1-1-1v-4.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V21a1 1 0 0 1-1 1H3.9A2 2 0 0 1 2 20V9.47c0-.57.25-1.1.7-1.47l6.6-5.1Z" />
    </svg>
  );
}

